import * as React from "react";
import PropTypes from "prop-types";
const SvgSportsSnowboardNormalSmall = React.forwardRef(
  ({ color = "currentColor", size = 24, title, titleId, ...props }, ref) => (
    <svg
      fill={color}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      ref={ref}
      width={size}
      height={size}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        d="M15.498 1.483a4.964 4.964 0 117.02 7.02c-1.12 1.12-2.435 2.257-3.715 3.364l-.017.014c-1.299 1.123-2.562 2.215-3.626 3.279s-2.156 2.327-3.278 3.626l-.015.016c-1.107 1.28-2.243 2.595-3.363 3.715a4.964 4.964 0 11-7.02-7.02c1.12-1.12 2.435-2.256 3.715-3.363l.017-.014c1.298-1.123 2.561-2.215 3.625-3.28 1.064-1.063 2.157-2.326 3.28-3.625l.014-.016c1.106-1.28 2.243-2.596 3.363-3.716zm5.606 1.414a2.964 2.964 0 00-4.192 0c-1.064 1.064-2.156 2.327-3.279 3.626l-.291.337c.407-.063.836.03 1.192.284l2.068 1.477c.62.443.874 1.19.729 1.874l.147-.127c1.299-1.123 2.562-2.215 3.626-3.28a2.964 2.964 0 000-4.19zm-10.849 7.358a48.186 48.186 0 01-2.124 1.977c.397-.017.8.11 1.126.384l1.924 1.629c.475.402.693.99.645 1.56a47.477 47.477 0 011.92-2.06 46.1 46.1 0 011.928-1.802 1.83 1.83 0 01-1.435-.532l-1.797-1.797a1.62 1.62 0 01-.476-1.184 45.066 45.066 0 01-1.71 1.825zM6.6 13.567l-.06.051-.016.015c-1.3 1.122-2.562 2.215-3.626 3.279a2.964 2.964 0 104.191 4.191c1.064-1.064 2.157-2.327 3.28-3.625l.014-.017.014-.016a1.84 1.84 0 01-1.81-.607L6.96 14.914a1.628 1.628 0 01-.359-1.347z"
        fill=""
      />
    </svg>
  )
);
SvgSportsSnowboardNormalSmall.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  title: PropTypes.string,
  titleId: PropTypes.string,
};
export default SvgSportsSnowboardNormalSmall;
